<template>
  <div class="page page-serve">
    <h3>Данные ТО</h3>
    <div class="col-button">
      <router-link v-if="car && car.id" :to="`/serve/${car.id}/create`" class="btn btn-primary">Провести ТО</router-link>
    </div>
    <ServeShow :car="car" />
    <ul class="nav nav-tabs justify-content-left">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#summary">Сводка</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#history">История</a>
      </li>
      <span class="tab-bar"></span>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade show active" id="summary">
        <table class="table plan-items-table">
          <thead>
            <th>Вид работы</th>
            <th>Дата/время последнего ТО</th>
            <th>Пробег на момент ТО, км</th>
            <th>Пробег после ТО, км</th>
            <th>Интервал, км</th>
            <th>Следующее ТО</th>
          </thead>
          <tbody v-if="car && car.servicePlan">
            <tr v-for="planItem in car.servicePlan" :key="planItem.name">
              <td>{{ planItem.name }}</td>
              <td>{{ toHumanFormat(fromUTCtranslate(planItem.datetime)) }}</td>
              <td>{{ planItem.total_odometer_stamp || '-' }}</td>
              <td>{{ afterService(planItem) }}</td>
              <td>{{ planItem.interval ? planItem.interval : 'не указан' }}</td>
              <td><ServiceState :distance="leftBeforeNext(planItem)" :afterService="afterService(planItem)" :interval="planItem.interval" /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul class="tab-pane history-pane fade loader" id="history">
        <li class="list-group-item history-item" v-for="service in carServices" :key="service.id">
          <span>Пробег: {{ service.total_odometer_stamp }} км</span>
          <span style="float: right; margin-right: 5px;">{{ service.datetime | diffForHumans }}
            <font-awesome-icon
              icon="trash-alt"
              size="1x"
              :style="{ color: 'gray', cursor: 'pointer' }"
              @click="deleteService(service)"
            /></span>
          <ul class="">
            <li v-for="work in service.serviceWorks" :key="work.id" class="">
              {{ work.name }}
            </li>
            <li v-if="service.notes" class="">
              {{ service.notes }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { djsMixin } from '@/components/mixins/djsMixin'
import serveAPI from '@/api/serve'
import serviceWorkAPI from '@/api/service-works'

export default {
  name: 'ServePage',
  props: ['carId'],
  mixins: [djsMixin],
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapState('taxi/servecars', {
      isLoading: state => state.isLoading
    })
  },
  data () {
    return {
      carServices: [],
      car: null
    }
  },
  methods: {
    ...mapActions('taxi/servecars', [
      'loadItem'
    ]),
    loadData () {
      serviceWorkAPI.getActiveServiceWorks()
        .then(serviceWorks => {
          this.loadItem({ id: this.carId, expand: ['servicePlan', 'lastState', 'nextServiceRecord'] }).then(response => {
            this.car = {
              ...response,
              servicePlan: serviceWorks.map(serviceWork => {
                const searchedIndex = response.servicePlan.findIndex(el => el.id == serviceWork.id)
                return searchedIndex === -1 ? serviceWork : response.servicePlan[searchedIndex]
              })
            }
          })
        })
      serveAPI.getItems({
        expand: 'serviceWorks',
        extra: {
          key: 'filter[and][][car_id]',
          value: this.carId
        },
        sort: '-datetime'
      }).promise.then(response => {
        this.carServices = response.items
      })
    },
    deleteService (service) {
      this.carServices = this.carServices.filter(x => x.id !== service.id)
      serveAPI.removeItem(service.id)
      this.loadData()
    },
    afterService (planItem) {
      if (!this.car.lastState || !this.car.lastState.totalOdometer ||
        !this.car.lastState.totalOdometer.value) {
        return 'н/д о пробеге'
      }

      if (!planItem.total_odometer_stamp) {
        return 'н/д'
      }

      return Math.ceil(this.car.lastState.totalOdometer.value / 1000) - planItem.total_odometer_stamp
    },
    leftBeforeNext (planItem) {
      if (!this.car.lastState || !this.car.lastState.totalOdometer ||
        !this.car.lastState.totalOdometer.value) {
        return null
      }

      if (!planItem.total_odometer_stamp) {
        return null
      }

      return planItem.interval - (Math.round(this.car.lastState.totalOdometer.value / 1000) - planItem.total_odometer_stamp)
    }
  }
}
</script>
<style scoped>
  .page-serve .btn-primary {
    width: 8rem;
    margin-left: 0.4rem;
    float: right !important;
  }
  .service-row {
    flex-direction: column;
    margin-bottom: 1rem;
  }
  .nav-tabs {
    border: none;
  }
  .history-pane {
    padding-left: 0;
    padding-right: 0;
  }
  .nav-item .nav-link {
    border: none;
    color: #212529;
  }
  .nav-item .nav-link.active {
    color: #0597f2;
    border-bottom: 2px solid #0597f2;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .tab-content {
    padding: 1rem 1rem 1rem 1rem;
  }
  .history-item {
    padding-left: min(1.60rem, 3%);
    padding-right: 2%;
  }

</style>
